<template>
	<div class="row" style="margin: 0; padding: 0px;border: 1px solid #1985AC;">
		<div v-show="record_id > 0" class="col-3" style=" padding: 0">
			<router-link :to="'/services/' + command_service_id + '/commands/' + record_id + ''">
				<button
					type="button"
					:class="'btn btn-primary btn-lg btn-block' + (current_tab == 'info' ? ' active' : '')"
				>
					{{ $t('About') }}
				</button>
			</router-link>
		</div>
		<div v-show="record_id == 0" class="col-3" style="padding: 0">
			<button
				type="button"
				:class="'btn btn-primary btn-lg btn-block' + (current_tab == 'info' ? ' active' : '')"
			>
				{{ $t('About') }}
			</button>
		</div>

		<div v-show="record_id > 0" class="col-3" style=" padding: 0">
			<router-link :to="'/services/' + command_service_id + '/commands/' + record_id + '/variables'">
				<button
					type="button"
					:class="'btn btn-primary btn-lg btn-block' + (current_tab == 'variables' ? ' active' : '')"
				>
					{{ $t('Variables') }}
				</button>
			</router-link>
		</div>
		<div v-show="record_id == 0" class="col-3" style=" padding: 0">
			<button type="button" class="btn btn-default btn-lg btn-block">{{ $t('Variables') }}</button>
		</div>
		<!-- /.col -->
		<div v-show="record_id > 0" class="col-3" style=" padding: 0">
			<router-link :to="'/services/' + command_service_id + '/commands/' + record_id + '/examples'">
				<button
					type="button"
					:class="'btn btn-primary btn-lg btn-block' + (current_tab == 'examples' ? ' active' : '')"
				>
					{{ $t('Examples') }}
				</button>
			</router-link>
		</div>
		<div v-show="record_id == 0" class="col-3" style=" padding: 0">
			<button type="button" class="btn btn-default btn-lg btn-block">{{ $t('Examples') }}</button>
		</div>
		<!-- /.col -->

		<div v-show="record_id > 0" class="col-3" style=" padding: 0">
			<router-link :to="'/services/' + command_service_id + '/commands/' + record_id + '/response'">
				<button
					type="button"
					:class="'btn btn-primary btn-lg btn-block' + (current_tab == 'response' ? ' active' : '')"
				>
					{{ $t('Response') }}
				</button>
			</router-link>
		</div>
		<!-- /.col -->
		<div v-show="record_id == 0" class="col-3" style=" padding: 0">
			<button type="button" class="btn btn-default btn-lg btn-block">{{ $t('Response') }}</button>
		</div>
		<!-- /.col -->
	</div>
</template>

<script>
// Define a new component called button-counter
export default {
	props: {
		command_service_id: {
			default: 1,
		},
		record_id: {
			default: 1,
		},
		active: {
			default: null,
		},
	},
	data() {
		return {
			current_tab: this.active,
		}
	},

	watch: {
		active() {
			this.current_tab = active
		},
	},

	mounted() {
		//
	},
}
</script>

